export default __webpack_public_path__ + "static/img/cursor.5010bea.png";